import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { createTracker } from 'usage-tracker';
import { getHubAndTierFromApiName } from './product';
import { getQueryParams } from './queryParams';
const AMPLITUDE_APP_NAME = 'upgrades';
export const tracker = createTracker({
  standalone: true
});
export const getDeployableName = () => {
  var _window$hubspot;
  // @ts-expect-error the error notes that bender is not defined on the
  // window.hubspot object, but it's documented in the auth docs:
  // https://product.hubteam.com/docs/appsystems/team-os/user-setup-fe/useful-info.html#how-to-check-which-app-your-looking-at
  return ((_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) || getApp();
};
const cleanUpEventProperties = (eventProperties = {}) => {
  Object.keys(eventProperties).forEach(property => {
    var _eventProperties$prop;
    if (((_eventProperties$prop = eventProperties[property]) !== null && _eventProperties$prop !== void 0 ? _eventProperties$prop : undefined) === undefined) {
      delete eventProperties[property];
    }
  });
  return eventProperties;
};
const isApiBlackListed = () => {
  return window.location.href.indexOf('sales-iframes') !== -1 || window.location.origin === 'https://preview.hs-sites.com' || window.location.origin === 'https://preview.hs-sitesqa.com';
};
export const track = (eventKey, eventProperties) => {
  if (isApiBlackListed()) {
    return;
  }
  tracker.track(AMPLITUDE_APP_NAME, eventKey, cleanUpEventProperties(eventProperties));
};
const getUpgradeSourceFromQueryParams = () => {
  var _getQueryParams$upgra;
  return (_getQueryParams$upgra = getQueryParams()['upgradeSource']) !== null && _getQueryParams$upgra !== void 0 ? _getQueryParams$upgra : null;
};
const getUpgradeConfigTrackingProperties = ({
  upgradeConfig
}) => {
  return {
    upgradeKey: upgradeConfig.upgradeKey,
    pointType: upgradeConfig.pointType,
    feature: upgradeConfig.featureStoreFeature
  };
};
const sources = {
  BUY_ADDITIONAL_SEATS: 'checkout',
  BUY_ADDITIONAL_CONTACTS: 'checkout',
  BUY_TOUCHLESS: 'checkout',
  REQUEST_ACCESS: 'general',
  PRICING_PAGE_REDIRECT: 'general',
  TALK_TO_SALES: 'contact-sales-button',
  TALK_TO_SALES_FALLBACK: 'contact-sales-button',
  TRIAL: 'trial-button',
  ASSIGN_SEAT: null,
  VIEW_ACCOUNT: null,
  REQUEST_SEAT: null,
  ADMIN_MODAL: null
};
const deriveSource = ({
  sourceKey,
  trackingData
}) => {
  const sourceValue = sources[sourceKey];
  if (sourceValue === null) {
    var _trackingData$source;
    return (_trackingData$source = trackingData.source) !== null && _trackingData$source !== void 0 ? _trackingData$source : trackingData.uniqueId;
  }
  return `${trackingData.app}-${trackingData.screen}-${sourceValue}-${trackingData.uniqueId}`;
};
export const getTrackingProperties = ({
  apiName,
  sourceKey,
  trackingData,
  upgradeConfig
}) => {
  const {
    hub,
    tier
  } = getHubAndTierFromApiName(apiName);
  const upgradeSource = getUpgradeSourceFromQueryParams();
  return Object.assign({
    app: trackingData.app,
    screen: trackingData.screen,
    subscreen: trackingData.subscreen,
    uniqueId: trackingData.uniqueId,
    apiName,
    source: deriveSource({
      sourceKey,
      trackingData
    }),
    upgradeProduct: ApiNameToUpgradeProductMap[apiName],
    upgradeSource
  }, trackingData.usageLimitBannerData, {
    hub,
    tier
  }, upgradeConfig ? getUpgradeConfigTrackingProperties({
    upgradeConfig
  }) : {});
};